__turbopack_context__.v({
  "fade": "mobile-visual-module__bmrjda__fade",
  "fadeFast": "mobile-visual-module__bmrjda__fadeFast",
  "maxH": "mobile-visual-module__bmrjda__maxH",
  "phoneScreen": "mobile-visual-module__bmrjda__phoneScreen",
  "root": "mobile-visual-module__bmrjda__root",
  "slideX": "mobile-visual-module__bmrjda__slideX",
  "slideY": "mobile-visual-module__bmrjda__slideY",
  "tone": "mobile-visual-module__bmrjda__tone",
  "width": "mobile-visual-module__bmrjda__width",
});
